import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { lowHeightScreens, smallScreens } from 'components/common/fontElements';

export const AlertContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: ${colors.lightGray7};
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const AlertReadMarker = styled.div`
  font-size: 9px;
  color: ${colors.darkGray1};
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 7px;
  }
`;
